export default __webpack_public_path__ + "static/media/american-express.1ea9ebcf.svg";